export const formatDate = (value) => {
  if (!value) {
    return { absolute: '—', relative: '—' };
  }

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) {
    return { absolute: '—', relative: '—' };
  }

  const pad2 = (n) => String(n).padStart(2, '0');

  // absolute: YYYY-MM-DD HH:mm (local)
  const y = d.getFullYear();
  const m = pad2(d.getMonth() + 1);
  const day = pad2(d.getDate());
  const hh = pad2(d.getHours());
  const mm = pad2(d.getMinutes());

  const absolute = `${y}-${m}-${day} ${hh}:${mm}`;

  // relative
  const now = new Date();
  const diffMs = now - d;
  const diffMin = Math.floor(diffMs / 60000);

  let relative = 'just now';

  if (diffMin < 1) {
    relative = 'just now';
  } else if (diffMin < 60) {
    relative = `${diffMin} min ago`;
  } else if (diffMin < 1440) {
    const h = Math.floor(diffMin / 60);
    relative = `${h} h ago`;
  } else if (diffMin < 2880) {
    relative = 'Yesterday';
  } else {
    const dDays = Math.floor(diffMin / 1440);
    relative = `${dDays} d ago`;
  }

  return { absolute, relative };
};

export const formatStatusLabel = (status) => {
  if (status === 'in_progress') return 'In Progress';
  if (status === 'finished') return 'Finished';
  if (status === 'archived') return 'Archived';
  return '—';
};
export const shortenText = (text, maxLength = 40) => {
  if (!text) return '—';
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1)}…`;
};
